import React, { useCallback } from 'react';
import { ChevronRight, ArrowLeft, CalendarDays, UserRound, HeartPulse } from 'lucide-react';

const BookingMethodSelector = ({ onSelect, onBack, selectedSpecialty, onChangeSpecialty }) => {
  const methods = [
    {
      id: 'date',
      name: 'Agendar por fecha',
      description: 'Elige el día y verás todas las doctoras con disponibilidad',
      Icon: CalendarDays,
      badge: 'Recomendado'
    },
    {
      id: 'doctor',
      name: 'Agendar por doctora',
      description: 'Elige primero a tu doctora y revisa su agenda semanal',
      Icon: UserRound
    },
    {
      id: 'condition',
      name: 'Agendar por condición',
      description: 'Filtra doctoras según el motivo de tu consulta',
      Icon: HeartPulse
    }
  ];

  // Memoizar el handler para evitar re-creaciones
  const handleMethodSelect = useCallback((methodId) => {
    onSelect(methodId);
  }, [onSelect]);

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <button onClick={onBack} className="press-scale mb-8 text-brand flex items-center gap-2 hover:gap-3 transition-all font-semibold">
        <ArrowLeft size={20} aria-hidden="true" />
        Volver
      </button>

      {/* Chip con la especialidad ya seleccionada — da contexto al usuario */}
      {selectedSpecialty && (
        <div className="flex justify-center mb-6">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-tint text-brand-deep rounded-full text-sm font-semibold">
            <span>Especialidad: <strong>{selectedSpecialty.name}</strong></span>
            {onChangeSpecialty && (
              <button
                onClick={onChangeSpecialty}
                className="ml-2 text-xs text-brand underline hover:text-brand-dark transition-colors"
              >
                Cambiar
              </button>
            )}
          </div>
        </div>
      )}

      <div className="text-center mb-8">
        <h2 className="text-[clamp(1.5rem,3.5vw,2.2rem)] font-bold text-brand-deep mb-3 tracking-[-0.025em]">
          ¿Cómo prefieres <span className="text-brand">agendar</span>?
        </h2>
        <p className="text-base md:text-lg text-text-body">Elige el método que mejor se adapte a tus necesidades</p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:gap-5">
        {methods.map((method) => (
          <button
            key={method.id}
            onClick={() => handleMethodSelect(method.id)}
            className="press-scale-card group bg-surface-card p-5 md:p-6 rounded-card transition-colors text-left flex items-center justify-between"
          >
            <div className="flex items-center gap-4 flex-1">
              <span className="flex items-center justify-center w-12 h-12 rounded-card-md bg-brand-tint text-brand shrink-0">
                <method.Icon size={24} aria-hidden="true" />
              </span>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h3 className="text-base md:text-lg font-semibold text-brand-deep">{method.name}</h3>
                  {method.badge && (
                    <span className="text-[11px] px-2 py-0.5 bg-amber-pill text-amber-deep rounded-full font-bold">
                      {method.badge}
                    </span>
                  )}
                </div>
                <p className="text-sm text-text-body leading-relaxed">{method.description}</p>
              </div>
            </div>

            <ChevronRight className="text-brand group-hover:translate-x-1 transition-transform ml-3 shrink-0" size={20} aria-hidden="true" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default BookingMethodSelector;
